import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Space, Checkbox, Button } from 'antd';
import parse from 'html-react-parser';
import IconNoData from '../../../../../assets/Images/icons/icon-no-data';
import months from '../../../months.json';
import moment from 'moment';

const TermConditionPreview = ({
    previewLang,
    templateDetail,
    logoCompany,
    masterTerm,
}) => {
    const { i18n } = useTranslation('consent');
    const [form] = Form.useForm();
    const lang = i18n?.language;

    const getConsent = (id) => {
        return masterTerm?.find((element) => {
            return id === element.consentTxnGroupId;
        });
    };

    const formatMonth = (month) => {
        console.log(lang);
        const item = months.find((res) => res.id === month + 1);
        return previewLang === 'th' ? item?.monthTh : item?.monthEn;
    };

    const formatYear = (year) => {
        return lang === 'th' ? year + 543 : year;
    };

    const getCurrentDate = (date) => {
        const currentDate = new Date(date);
        const day = currentDate.getDate();
        const month = formatMonth(Number(currentDate.getMonth()));
        const year = formatYear(Number(currentDate.getFullYear()));
        const formatDate = `${day} ${month} ${year}`;
        return formatDate;
    };

    useEffect(() => {
        form.resetFields();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [templateDetail]);

    return (
        <>
            {templateDetail ? (
                <Form form={form} wrapperCol={{ span: 8 }}>
                    <div className="bg-white rounded-md whitespace-pre-line border-solid border-[#ECECEC] p-6 mt-2 leading-7 overflow-auto max-h-[700px]">
                        <div className="text-center">
                            <div
                                className="text-center my-4 justify-center"
                                hidden={!logoCompany}
                            >
                                <img
                                    src={logoCompany}
                                    className="object-cover w-auto h-20"
                                    alt="logo"
                                />
                            </div>
                        </div>
                        <div
                            className="text-center text-xl font-semibold whitespace-pre-wrap"
                            style={{ wordBreak: 'break-word' }}
                        >
                            {previewLang === 'en'
                                ? parse(templateDetail?.titleEn || '-')
                                : parse(templateDetail?.titleTh || '-')}
                        </div>
                        <div
                            className="my-2"
                            style={{ borderBottom: '1px solid #EDEEF9' }}
                        ></div>

                        {templateDetail?.consentTxnGroupId && (
                            <>
                                <div className="text-sm font-semibold whitespace-pre-wrap">
                                    {previewLang === 'en'
                                        ? parse(
                                              templateDetail?.templateNameEn ||
                                                  '-'
                                          )
                                        : parse(
                                              templateDetail?.templateNameTh ||
                                                  '-'
                                          )}
                                </div>
                                <div className="text-sm font-base whitespace-pre-wrap">
                                    {previewLang === 'en'
                                        ? parse(
                                              getConsent(
                                                  templateDetail?.consentTxnGroupId
                                              )?.purposeEn || '-'
                                          )
                                        : parse(
                                              getConsent(
                                                  templateDetail?.consentTxnGroupId
                                              )?.purposeTh || '-'
                                          )}
                                </div>
                            </>
                        )}
                        <div className="text-sm font-base whitespace-pre-wrap my-4">
                            {templateDetail?.effectiveDate &&
                                (previewLang === 'en'
                                    ? `This document was last updated on ${getCurrentDate(
                                          moment(templateDetail?.effectiveDate)
                                              ?.format(
                                                  'YYYY-MM-DDT00:00:00.000+00:00'
                                              )
                                              ?.split('T')[0]
                                              ?.split('T')[0] || '-'
                                      )}`
                                    : `เอกสารฉบับนี้ปรับปรุงล่าสุดเมื่อ ${getCurrentDate(
                                          moment(templateDetail?.effectiveDate)
                                              ?.format(
                                                  'YYYY-MM-DDT00:00:00.000+00:00'
                                              )
                                              ?.split('T')[0]
                                              ?.split('T')[0] || '-'
                                      )}`)}
                        </div>

                        {templateDetail?.showAcknowledgeButton === true && (
                            <>
                                <div className="my-2">
                                    <Checkbox.Group size="large">
                                        <Space direction="vertical">
                                            <Checkbox
                                                className={`bg-[#F4F6FC] rounded-lg px-4 py-2`}
                                                key={`_Accept`}
                                                style={{ lineHeight: '32px' }}
                                            >
                                                {previewLang === 'en'
                                                    ? 'Agree to the terms and conditions.'
                                                    : 'รับทราบข้อกำหนดและเงื่อนไข'}
                                            </Checkbox>
                                        </Space>
                                    </Checkbox.Group>

                                    <div
                                        className="my-4"
                                        style={{
                                            borderBottom: '1px solid #EDEEF9',
                                        }}
                                    ></div>
                                    <div className="text-sm font-semibold whitespace-pre-wrap">
                                        {previewLang === 'en'
                                            ? 'Provide consent information as of (date) ...'
                                            : 'ให้ข้อมูลความยินยอม ณ วันที่ ...'}{' '}
                                    </div>
                                    <div className="text-center justify-center items-center">
                                        <Button
                                            size="large"
                                            htmlType="submit"
                                            type="primary"
                                            className="px-9"
                                        >
                                            {previewLang === 'en'
                                                ? 'Submit'
                                                : 'ยืนยัน'}
                                        </Button>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </Form>
            ) : (
                <div className="bg-white rounded-md whitespace-pre-line border-solid border-[#ECECEC] p-6 mt-2 leading-7 overflow-auto max-h-[700px]">
                    <div className="text-center text-sm space-y-2 my-56">
                        <IconNoData />
                        <p className="text-[#65707A] text-[14px]">
                            {lang === 'en' ? 'No Data' : 'ไม่พบข้อมูล'}
                        </p>
                    </div>
                </div>
            )}
        </>
    );
};

export default TermConditionPreview;
